import React, { useState, createContext } from 'react';
import { FiltersForQuery } from 'src/graphql/_generated';

type DeepOmitTypename<T> =
  T extends Array<infer U>
    ? Array<DeepOmitTypename<Omit<U, '__typename'>>>
    : T extends object
      ? { [K in keyof T]: DeepOmitTypename<T[K]> }
      : T;

export type FiltersType = DeepOmitTypename<Omit<NonNullable<FiltersForQuery['filtersFor']['controls']>, '__typename'>>;

export type ModalType = keyof FiltersType;

interface FiltersContextInterface {
  modalType: ModalType | null;
  setModalType: React.Dispatch<React.SetStateAction<ModalType | null>>;
  filters: FiltersType;
  setFilters: React.Dispatch<React.SetStateAction<FiltersType>>;
  isInit: boolean;
  setIsInit: React.Dispatch<React.SetStateAction<boolean>>;
}

const FiltersContext = createContext<Partial<FiltersContextInterface>>({});

const FiltersProvider = (props: any) => {
  const [isInit, setIsInit] = useState(false);
  const [modalType, setModalType] = useState<ModalType | null>(null);
  const [filters, setFilters] = useState<FiltersType>({
    strategy: [],
    status: [],
    owners: [],
    frameworks: [],
    assessments: [],
    existingMaturity: [],
    targetMaturity: [],
  });

  return (
    <FiltersContext.Provider
      value={{
        modalType,
        setModalType,
        filters,
        setFilters,
        isInit,
        setIsInit,
      }}
      {...props}
    />
  );
};

const useFiltersState = () => {
  const context = React.useContext(FiltersContext);
  if (context === undefined) {
    throw new Error('useFiltersState must be used within a FiltersProvider');
  }
  return context as FiltersContextInterface;
};

export { FiltersProvider, useFiltersState };
